import { env, EnvType } from './env.ts';
import packageJson from '../../package.json';

export interface AppConfig {
  environment: 'local' | 'development' | 'uat' | 'production';
  version: string;
  apiUrl: string;
  graphQlUrl: string;
  auth0Domain: string;
  auth0ClientId: string;
  auth0CallbackUrl: string;
  auth0Audience: string;
  sentryDsn: string;
  sentryReplaySampleRate?: number;
  sentryTraceSampleRate?: number;
  googleMapsAPIKey: string;
  pageTitlePrefix: string;
}

const throwIfUndefined = (envVar: keyof EnvType): string => {
  if (env[envVar] === undefined) {
    throw new Error(`${String(envVar)} is not defined, cannot load application config`);
  }

  return env[envVar]!;
};

let config: AppConfig;

export const getConfig = (): AppConfig => {
  if (config) return config;
  let deploymentTarget = throwIfUndefined('VITE_ENV');
  if (!['local', 'development', 'uat', 'production'].includes(deploymentTarget)) {
    deploymentTarget = 'production';
  }

  config = {
    environment: deploymentTarget as 'local' | 'development' | 'uat' | 'production',
    version: packageJson.version.trim(),
    apiUrl: throwIfUndefined('VITE_BACKEND_HOST'),
    graphQlUrl: throwIfUndefined('VITE_GRAPHQL_URL'),
    auth0Domain: throwIfUndefined('VITE_AUTH0_DOMAIN'),
    auth0ClientId: throwIfUndefined('VITE_AUTH0_CLIENT_ID'),
    auth0CallbackUrl: throwIfUndefined('VITE_AUTH0_CALLBACK_URL'),
    auth0Audience: throwIfUndefined('VITE_AUTH0_AUDIENCE'),
    sentryDsn: env['VITE_SENTRY_DSN'],
    sentryReplaySampleRate: env['VITE_SENTRY_REPLAY_SAMPLE_RATE'] ? parseFloat(env['VITE_SENTRY_REPLAY_SAMPLE_RATE']) : undefined,
    sentryTraceSampleRate: env['VITE_SENTRY_TRACE_SAMPLE_RATE'] ? parseFloat(env['VITE_SENTRY_TRACE_SAMPLE_RATE']) : undefined,
    googleMapsAPIKey: env['VITE_GOOGLE_MAPS_API_KEY'],
    pageTitlePrefix: env['VITE_PAGE_TITLE_PREFIX'],
  };
  return config;
};
